import styled from '../../../styles/theme';
import { MonthlyPriceLabelStyled } from '../MonthlyPriceLabelStyled';

export const MonthlyPriceLabelStyledOV = styled(MonthlyPriceLabelStyled)`
  
`;
